import React from 'react';
import { useFormField } from '../../useFormField';
import type { StripControlledProperties } from '../../types';
import { ColorPicker, type ColorPickerProps } from '../../../components/color/ColorPicker';
import type { Color } from 'react-aria-components';

interface ColorPickerFormFieldProps extends StripControlledProperties<Omit<ColorPickerProps, 'onChange' | 'value' | 'label'>> {
	onChangePassthrough?: (selected: string) => void;
}

export function ColorPickerFormField(props: ColorPickerFormFieldProps) {
	const fieldProps = useFormField<string>(props);

	const onSelectionChange = (value: Color) => {
		fieldProps.onChange(value?.toString('hex'));
		props.onChangePassthrough?.(value?.toString('hex'));
	};

	return <ColorPicker {...fieldProps} value={fieldProps.value} onChange={onSelectionChange} />;
}
